import styled from '@emotion/styled';
import { ContentBox } from 'screens/MadadArchivePage/2021/styled';

export const Root = styled(ContentBox.withComponent('section'))`
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    padding: 0;
  `}
`;

export const InnerContent = styled.div`
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: 0 ${theme.spacing(3)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 3 })`
    padding: ${theme.spacing(8)} ${theme.spacing(5)} 0;
  `}
`;
